import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import DeviceCascader from '@blade-sxp/task-management/components/device-cascader.vue';
import TrafficPoint from './traffic-point.vue';
import { TrafficTypeModule } from '@blade-sxp/task-management/store/traffic-type';
import NoDeviceId from '@blade-sxp/task-management/components/deviceDarwer/no-device-id.vue';
let TrafficType = class TrafficType extends Vue {
    disabled;
    deviceIdListData;
    multiple = true;
    deviceIdList = this.$props.deviceIdListData;
    isTreeData = false;
    searchCondition = {
        excludeUngroupDevice: true,
        filterVpsSupport: true,
    };
    get deviceStyle() {
        return `height:51rem;min-width:112rem;min-height:51rem;width:112rem;margin-top: 16px`;
    }
    get isDevice() {
        return this.deviceIdList?.length > 0;
    }
    onchnageDeviceList(val) {
        this.$emit('update:deviceIdListData', val);
    }
    removeValue(val) {
        const isKey = TrafficTypeModule.retrogradeMapData.has(val);
        if (isKey) {
            TrafficTypeModule.retrogradeMapData.delete(val);
        }
    }
    dataFinishStatus(val) {
        this.isTreeData = val;
    }
    deviceIdRest(val) {
        if (val && val.length === 0) {
            TrafficTypeModule.retrogradeMapData.clear();
        }
    }
    deleteDeviceId(id) {
        this.removeValue(id);
        const index = this.deviceIdList.indexOf(id);
        if (index > -1) {
            const data = [...this.deviceIdList];
            data.splice(index, 1);
            this.deviceIdList = data;
        }
    }
};
__decorate([
    Prop({ default: false, type: Boolean })
], TrafficType.prototype, "disabled", void 0);
__decorate([
    Prop({ default: () => [], type: Array })
], TrafficType.prototype, "deviceIdListData", void 0);
__decorate([
    Watch('deviceIdList', { immediate: true })
], TrafficType.prototype, "onchnageDeviceList", null);
TrafficType = __decorate([
    Component({
        name: 'TrafficType',
        components: {
            'device-cascader': DeviceCascader,
            'traffic-point': TrafficPoint,
            'no-device-id': NoDeviceId,
        },
        i18n: {
            messages: {
                en: {
                    device: 'Device',
                },
                zh: {
                    device: '设备',
                },
            },
        },
    })
], TrafficType);
export default TrafficType;
